import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { pblVettingStatusLabels } from '@/data/pbl';
import type { PblVettingStatus } from '@/types/pbl';

const statusColor: Record<PblVettingStatus, { color: string; background: string }> = {
  pending_review: { color: '#ffffff', background: '#ffb802' },
  approved: { color: '#ffffff', background: '#7eb442' },
  resubmit_required: { color: '#ffffff', background: '#ff6d00' },
  rejected: { color: '#ffffff', background: '#dc1010' },
  inactive: { color: '#ffffff', background: '#999999' },
  withdrawn: { color: '#ffffff', background: '#5c6470' },
};

const statusDisplayLabel: Record<PblVettingStatus, string> = {
  ...pblVettingStatusLabels,
  pending_review: 'Pending',
};

const statusLabelKeys: Record<PblVettingStatus, string> = {
  pending_review: 'pbl.lawyerVetting.list.tabs.pending',
  approved: 'pbl.lawyerVetting.list.tabs.approved',
  resubmit_required: 'pbl.lawyerVetting.list.tabs.underResubmission',
  rejected: 'pbl.lawyerVetting.list.tabs.rejected',
  inactive: 'pbl.lawyerVetting.list.tabs.inactive',
  withdrawn: 'pbl.lawyerVetting.list.tabs.withdrawn',
};

const Badge = styled.span<{ status: PblVettingStatus }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 116px;
  height: 28px;
  padding: 0 16px;
  border-radius: ${(p) => p.theme.radii.base};
  color: ${(p) => statusColor[p.status].color};
  background: ${(p) => statusColor[p.status].background};
  font-size: ${(p) => p.theme.fontSizes.xs};
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
`;

const PblVettingStatusBadge = ({ status }: { status: PblVettingStatus }) => {
  //   @ts-ignore
  const { t } = useTranslation();
  const label = t(statusLabelKeys[status] as any, { defaultValue: statusDisplayLabel[status] }) as string;

  return <Badge status={status}>{label}</Badge>;
};

export default PblVettingStatusBadge;
